<template>
	<div class="col" gutter="20">
		<Title title="管理會員" />
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="姓名、Email、單位、地區、職位" />
		<div class="col" align-x="left" gutter="20">
			<el-button type="info" @click="handleDownload()">下載會員資料</el-button>
			<el-radio-group v-model="status" @change="statusChange">
				<el-radio-button label="全部" />
				<el-radio-button label="執行挑戰中" />
				<el-radio-button label="未執行挑戰" />
				<!-- <el-radio-button label="曾執行挑戰" /> -->
			</el-radio-group>
		</div>
		<el-pagination align-self="right" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="userList.total" />
		<el-table :data="userList.list" style="width: 100%" :default-sort="{prop: 'create_time', order: 'descending'}">
			<el-table-column prop="name" label="姓名" />
			<el-table-column prop="jobs" label="地區">
				<template slot-scope="{row}">
					{{mapJob(row.jobs).city}}
				</template>
			</el-table-column>
			<el-table-column prop="jobs" label="單位" sortable>
				<template slot-scope="{row}">
					{{mapJob(row.jobs).department}}
				</template>
			</el-table-column>
			<el-table-column prop="jobs" label="職位" sortable>
				<template slot-scope="{row}">
					{{mapJob(row.jobs).position}}
				</template>
			</el-table-column>
			<el-table-column prop="email" label="Email" />
			<el-table-column prop="create_time" label="加入時間" sortable>
				<template slot-scope="{row}">
					{{transformTimestamp(row.create_time)}}
				</template>
			</el-table-column>
			<el-table-column label="報名挑戰" align="center" sortable>
				<template slot-scope="{row}">
					{{row.stories && row.stories.length > 0 ? "執行挑戰中" : "未執行挑戰"}}
				</template>
			</el-table-column>
			<el-table-column align="center">
				<template slot-scope="{row}">
					<router-link :to="{name: 'manageMember', params:{id: row.id}}">詳細資料</router-link>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination align-self="right" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="userList.total" />

		<div style="width:0;height:0;overflow:hidden;">
			<table ref="downloadTable" v-html="tbody" border="1"></table>
		</div>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import moment from "moment-timezone"
import xlsx from "@/libs/xlsx";

export default {
	mixins: [xlsx],
	components: { Title, SearchBar },
	data() {
		return {
			page: 1,
			size: 10,
			searchText: "",
			status: "全部",
			downloadList: [],
			tbody: ""
		};
	},
	computed: {
		...mapState('manager', ['userList']),
		query() {
			return {
				page: this.page,
				size: this.size,
				text: this.searchText,
				status: this.status
			};
		}
	},
	watch: {
		async $route(val) {
			await this.getUserList(this.query);
		}
	},
	methods: {
		...mapActions('manager', ['getUserList', 'getAllUsers']),
		init() {
			this.page = Number(this.$route.query.page) || 1;
			this.size = Number(this.$route.query.size) || 10;
			this.searchText = this.$route.query.text || '';
			this.status = this.$route.query.status || '全部';
		},
		handleSearch(text) {
			this.searchText = text;
			this.page = 1;
			this.$router.replace({ query: this.query });
		},
		sizeChange(size) {
			this.size = size;
			this.page = 1;
			this.$router.replace({ query: this.query });
		},
		currentChange(page) {
			this.page = page;
			this.$router.replace({ query: this.query });
		},
		statusChange(status) {
			this.status = status;
			this.page = 1;
			this.$router.replace({ query: this.query });
		},
		transformTimestamp(timestamp) {
			return moment(timestamp).tz("Asia/Taipei").format("YYYY-MM-DD");
		},
		mapJob(jobs = []) {
			const jobList = jobs.filter(j => j.presently_employed);
			if (jobList.length > 0) {
				return jobList.reduce((a, b) => b.start_time > a.start_time ? b : a);
			} else {
				if (jobs.length > 0) {
					return jobs.reduce((a, b) => b.end_time > a.end_time ? b : a);
				}
				return new Object;
			}
		},
		async handleDownload() {
			this.downloadList = await this.getAllUsers();
			let tbody = `<tr>
				<th colspan="7">基本資料</th>
				<th colspan="4">工作經歷</th>
				<th colspan="3">追蹤</th>
			</tr>`;
			tbody += `<tr>
				<th>姓名</th>
				<th>羅馬拼音</th>
				<th>性別</th>
				<th>電子郵件</th>
				<th>出生年月日</th>
				<th>手機</th>
				<th>學校電話（分機）</th>
				<th>介紹人</th>

				<th>在職時間</th>
				<th>職業</th>
				<th>單位名稱</th>
				<th>地區</th>

				<th>加入時間</th>
				<th>上次登入時間</th>
				<th>是否執行挑戰</th>
			</tr>`;
			this.downloadList.forEach(row => {
				if (row.jobs) {
					let row_num = row.jobs.length;
					for (let i = 0; i < row_num; i++) {
						tbody += "<tr>"
						if (i == 0) {
							tbody += `
								<td rowspan="${row_num}">${row.name || ""}</td>
								<td rowspan="${row_num}">${row.wade_giles || ""}</td>
								<td rowspan="${row_num}">${row.gender || ""}</td>
								<td rowspan="${row_num}">${row.account || ""}</td>
								<td rowspan="${row_num}">${this.transformTimestamp(row.born_date) || ""}</td>
								<td rowspan="${row_num}">${row.phone || ""}</td>
								<td rowspan="${row_num}">${row.tel || ""}</td>
								<td rowspan="${row_num}">${row.introducer || ""}</td>`
						}
						tbody += `
							<td>${row.jobs[i] && `${this.transformTimestamp(row.jobs[i].start_time)} ～ ${row.jobs[i].presently_employed ? "至今" : this.transformTimestamp(row.jobs[i].end_time)}` || ""}</td>
							<td>${row.jobs[i] && row.jobs[i].type || ""}</td>
							<td>${row.jobs[i] && row.jobs[i].department || ""}</td>
							<td>${row.jobs[i] && row.jobs[i].city || ""}</td>`
						if (i == 0) {
							tbody += `
								<td rowspan="${row_num}">${row.create_time && this.transformTimestamp(row.create_time) || ""}</td>
								<td rowspan="${row_num}">${row.login_time && moment(row.login_time).tz("Asia/Taipei").format("YYYY-MM-DD，HH:mm") || ""}</td>
								<td rowspan="${row_num}">${row.stories && row.stories.length > 0 ? "Y" : "N"}</td>`
						}
						tbody += "</tr>"
					}
				}
			});
			this.tbody = tbody;
			this.$nextTick(() => {
				this.saveAsXLSX(this.$refs["downloadTable"], "會員資料.xlsx");
			});
		}
	},
	async created() {
		this.init();
		await this.getUserList(this.query);
	}
};
</script>

<style lang="scss" scoped>
</style>